export type Rank = 'bronze' | 'silver' | 'gold' | 'platinum' | 'diamond' | 'master';

export type Sport = 'football' | 'volleyball' | 'badminton' | 'tabletennis' | 'tennis' | 'pickleball' | 'basketball' | 'swimming' | 'golf' | 'billiards' | 'running' | 'cycling';

export interface User {
  id: string;
  name: string;
  avatar: string;
  age: number;
  gender: 'male' | 'female' | 'other';
  rank: Rank;
  rankPoints: number;
  sports: Sport[];
  clubs: string[];
  matchesPlayed: number;
  wins: number;
  losses: number;
  location: string;
}

export interface Club {
  id: string;
  name: string;
  avatar: string;
  sport: Sport;
  location: string;
  memberCount: number;
  rating: number;
  reviewCount: number;
  isRecruiting: boolean;
  isLookingForMatch: boolean;
  tags: string[];
  description: string;
  rank?: Rank;
  rank_points?: number;
  wins?: number;
  losses?: number;
  matches_played?: number;
}

export interface Match {
  id: string;
  sport: Sport;
  type: '1v1' | 'team';
  status: 'upcoming' | 'ongoing' | 'completed' | 'cancelled';
  date: string;
  time: string;
  location: string;
  participants: User[];
  teams?: { team1: User[]; team2: User[] };
  result?: {
    winner: string;
    score: string;
  };
}

export interface Review {
  id: string;
  userId: string;
  userName: string;
  userAvatar: string;
  clubId: string;
  rating: number;
  comment: string;
  tags: string[];
  createdAt: string;
}

export const RANK_ORDER: Rank[] = ['bronze', 'silver', 'gold', 'platinum', 'diamond', 'master'];

export const SPORT_LABELS: Record<Sport, string> = {
  football: 'Bóng đá',
  volleyball: 'Bóng chuyền',
  badminton: 'Cầu lông',
  tabletennis: 'Bóng bàn',
  tennis: 'Tennis',
  pickleball: 'Pickleball',
  basketball: 'Bóng rổ',
  swimming: 'Bơi lội',
  golf: 'Golf',
  billiards: 'Bi-a',
  running: 'Chạy bộ',
  cycling: 'Đạp xe',
};

export const RANK_LABELS: Record<Rank, string> = {
  bronze: 'Bronze',
  silver: 'Silver',
  gold: 'Gold',
  platinum: 'Platinum',
  diamond: 'Diamond',
  master: 'Master',
};
